import { EditableFieldProps } from '../core-field/editable-field-json-props'

export const UI2_CHECKBOX_FIELD_DEFAULT_PROPS: Partial<UI2CheckboxFieldProps> = {
  /** @platform web — mobile renders checkbox always in stacked layout. */
  isHorizontalLayout: true,
}

export interface UI2CheckboxFieldProps extends EditableFieldProps<boolean> {}
